<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="buscar">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <h3 class="mb-4 mt-4">Novo Cancelamento</h3>
      <hr class="mb-6" />
      <div v-if="!this.$route.params.idCancelamento" class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <span>Placa</span>
          <vs-input
            v-mask="'AAA-#XX#'"
            size="large"
            class="w-full"
            name="Placa"
            id="Placa"
            v-validate="{ required: true, min: 8 }"
            v-model="form.placa"
            :state="validateState('Placa')"
            :danger="validateClass('Placa')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
        <div class="vx-col sm:w-1/6 mt-4 text-right">
          <BotaoSubmit
            variant="warning"
            :edit="true"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
            text="Buscar"
          ></BotaoSubmit>
        </div>
      </div>
      <vs-row v-if="dadosResult">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card
            ><div slot="header">
              <h3>Dados do Beneficiário</h3>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Nome</th>
                <td>{{ dadosResult.associado.nome }}</td>
              </tr>
              <tr>
                <th class="uppercase">Email</th>
                <td>{{ dadosResult.associado.email }}</td>
              </tr>
              <tr>
                <th class="uppercase">CPF/CNPJ</th>
                <td>{{ dadosResult.associado.cpfcnpj }}</td>
              </tr>
              <tr>
                <th class="uppercase">Telefone</th>
                <td>{{ dadosResult.associado.telefone }}</td>
              </tr>
              <tr>
                <th class="uppercase">Celular</th>
                <td>{{ dadosResult.associado.celular }}</td>
              </tr>
              <tr>
                <th class="uppercase">Cep</th>
                <td>{{ dadosResult.associado.cep }}</td>
              </tr>
              <tr>
                <th class="uppercase">Endereço</th>
                <td>
                  {{ dadosResult.associado.endereco }},
                  {{ dadosResult.associado.numero }}
                  {{ dadosResult.associado.complemento }}<br />
                  {{ dadosResult.associado.bairro }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Cidade / UF</th>
                <td>
                  {{ dadosResult.associado.cidade }} /
                  {{ dadosResult.associado.estado }}
                </td>
              </tr>
            </table>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card
            ><div slot="header">
              <h3>Dados do Veículo</h3>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Placa</th>
                <td>{{ dadosResult.veiculo.placa }}</td>
              </tr>
              <tr>
                <th class="uppercase">Categoria</th>
                <td>{{ dadosResult.veiculo.categoria }}</td>
              </tr>
              <tr>
                <th class="uppercase">Marca</th>
                <td>{{ dadosResult.veiculo.marca }}</td>
              </tr>
              <tr>
                <th class="uppercase">Modelo</th>
                <td>{{ dadosResult.veiculo.modelo }}</td>
              </tr>
              <tr>
                <th class="uppercase">Ano</th>
                <td>
                  {{ dadosResult.veiculo.ano_fabricacao }} /
                  {{ dadosResult.veiculo.ano_modelo }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Fipe</th>
                <td>{{ dadosResult.veiculo.codigo_fipe }}</td>
              </tr>
              <tr>
                <th class="uppercase">Chassi</th>
                <td>{{ dadosResult.veiculo.chassi }}</td>
              </tr>
              <tr>
                <th class="uppercase">Renavam</th>
                <td>{{ dadosResult.veiculo.renavam }}</td>
              </tr>
              <tr>
                <th class="uppercase">Situação</th>
                <td>{{ dadosResult.veiculo.descricao_situacao }}</td>
              </tr>
            </table>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Boletos</h3>
            </div>
            <div
              v-if="dadosResult.boletos.length == 0"
              class="bg-danger text-white p-3"
            >
              Nenhum boleto encontrado
            </div>
            <div v-else>
              <table
                v-for="item in dadosResult.boletos"
                :key="item.id"
                class="table table-bordered tableboletos"
              >
                <tr>
                  <th>Tipo</th>
                  <th>Situação</th>
                  <th>Vencimento</th>
                </tr>
                <tr>
                  <td>{{ item.tipo_boleto }}</td>
                  <td>{{ item.situacao_boleto }}</td>
                  <td>{{ formataData(item.data_vencimento) }}</td>
                </tr>
                <tr>
                  <td colspan="3" v-if="item.situacao_boleto == 'ABERTO'">
                    Linha {{ item.linha_digitavel }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Produtos</h3>
            </div>
            <div
              v-if="dadosResult.produtos.length == 0"
              class="bg-danger text-white p-3"
            >
              Nenhum Produto encontrado
            </div>
            <div v-else>
              <table class="table table-bordered">
                <tr>
                  <th>Produto</th>
                  <th>Valor</th>
                </tr>
                <tr v-for="item in dadosResult.produtos" :key="item.id">
                  <td>{{ item.descricao }}</td>
                  <td>{{ item.valor | currency }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </form>
    <div v-if="dadosResult">
      <vs-row>
        <vs-col>
          <vs-button
            v-if="iniciar == false"
            @click="iniciar = true"
            type="gradient"
            icon-pack="feather"
            icon="icon-refresh-ccw"
            >Iniciar Processo de Cancelamento</vs-button
          >
        </vs-col>
      </vs-row>
      <div v-if="iniciar == true">
        <div class="vx-row mt-8 mb-6">
          <div class="vx-col w-full">
            <vs-select
              v-if="!dadosResult.cancelamento"
              v-model="form.idMotivo"
              label="Motivo de Cancelamento"
              class="select-large w-full"
              name="Motivo de Cancelamento"
              autocomplete
              @change="filtraPerguntas()"
              v-validate="{ required: true }"
              :state="validateState('Motivo de Cancelamento')"
              :danger="validateClass('Motivo de Cancelamento')"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in motivos"
              />
            </vs-select>
            <div v-else>
              Motivo de Cancelamento: {{ dadosResult.cancelamento.motivo }}
            </div>
          </div>
        </div>
        <vs-card
          v-if="dadosResult.respostas && dadosResult.respostas.length > 0"
        >
          <div slot="header">
            <h3>Respostas</h3>
          </div>
          <div
            v-if="dadosResult.respostas.length == 0"
            class="bg-danger text-white p-3"
          >
            Nenhuma Resposta encontrado
          </div>
          <div v-else>
            <table class="table table-bordered">
              <tr>
                <th>Pergunta</th>
                <th>Resposta</th>
              </tr>
              <tr v-for="item in dadosResult.respostas" :key="item.id">
                <td>{{ item.pergunta }}</td>
                <td>{{ item.resposta }}</td>
              </tr>
            </table>
          </div>
        </vs-card>

        <div v-else-if="perguntasFilter.length > 0 && form.idMotivo">
          <div v-for="item in perguntasFilter" :key="item.id">
            <vs-card v-if="showOrDont(item)">
              <div slot="header">
                <h5>
                  {{ item.pergunta }}
                </h5>
              </div>
              <vs-select
                v-if="item.isNota == false && item.isAberta == false"
                v-model="item.resposta"
                label="Resposta"
                class="select-large w-full"
                name="Resposta"
                v-validate="{ required: true }"
                :state="validateState('Resposta')"
                :danger="validateClass('Resposta')"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.id"
                  v-for="(item, index) in respostasPadrao"
                />
              </vs-select>
              <div v-else-if="item.isNota == true">
                <vs-select
                  v-model="item.resposta"
                  label="Nota de 0 a 10"
                  class="select-large w-full"
                  name="Resposta"
                  v-validate="{ required: true }"
                  :state="validateState('Resposta')"
                  :danger="validateClass('Resposta')"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.id"
                    v-for="(item, index) in respostasNota"
                  />
                </vs-select>
              </div>
              <div v-else-if="item.isAberta == true">
                <vs-textarea label="Resposta Aberta" v-model="item.resposta" />
              </div>
            </vs-card>
          </div>
        </div>
        <div v-if="perguntasFilter.length > 0 && form.idMotivo">
          <vs-row
            vs-justify="flex-end"
            v-if="
              form.idMotivo == 1 || form.idMotivo == 2 || form.idMotivo == 5
            "
          >
            <vs-button
              v-if="
                (form.idMotivo == 5 && perguntasFilter[0].resposta == 'Sim') ||
                form.idMotivo == 2
              "
              @click="popComercial = true"
              type="gradient"
              color="danger"
              icon="thumb_down"
              >Não Retido</vs-button
            >
            <vs-button
              v-else
              @click="naoRetido()"
              type="gradient"
              color="danger"
              icon="thumb_down"
              >Não Retido</vs-button
            >

            <vs-button
              v-if="form.idMotivo != 5 && form.idMotivo != 2"
              @click="popRetido = true"
              type="gradient"
              color="success"
              icon="thumb_up"
              >Retido</vs-button
            >
          </vs-row>
          <div
            v-if="
              !dadosResult.cancelamento ||
              dadosResult.cancelamento.status == 'Não Iniciado'
            "
          >
            <vs-row vs-justify="flex-end" v-if="form.idMotivo == 3">
              <vs-button
                @click="IniciaNegociacao()"
                type="gradient"
                color="dark"
                >Iniciar Negociação</vs-button
              >
            </vs-row>
            <vs-row vs-justify="flex-end" v-if="form.idMotivo == 4">
              <vs-button
                @click="IniciaNegociacao()"
                type="gradient"
                color="dark"
                >Iniciar Processo Ouvidoria</vs-button
              >
            </vs-row>
          </div>
          <vs-row
            vs-justify="flex-end"
            v-else-if="dadosResult.cancelamento.status == 'Em Negociação'"
          >
            <vs-button
              @click="naoRetido()"
              type="gradient"
              color="danger"
              icon="thumb_down"
              >Não Retido</vs-button
            >

            <vs-button
              @click="popRetido = true"
              type="gradient"
              color="success"
              icon="thumb_up"
              >Retido</vs-button
            >
          </vs-row>
        </div>
      </div>
    </div>

    <vs-popup
      :title="'Retido'"
      @close="popRetido = false"
      :active.sync="popRetido"
    >
      <div class="con-exemple-prompt">
        <vs-select
          v-model="form.usuarioResponsavel"
          label="Chamado para Usuário Responsável"
          class="select-large w-full mb-3"
          name="Usuário Responsável"
          autocompletes
          :state="validateState('Usuário Responsável')"
          :danger="validateClass('Usuário Responsável')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in usuarios"
          />
        </vs-select>
        <vs-textarea
          placeholder="Insira a observação da negociação, esse texto será direcionado por chamado"
          v-model="form.observacao"
        />
      </div>
      <vs-button @click="isReducao()" color="dark" class="mb-2 my-5">
        <span>Solicitar Redução</span>
      </vs-button>
      <vs-button @click="isSuspensao()" color="dark" class="mb-2 my-5 ml-2">
        <span>Solicitar Suspensão</span>
      </vs-button>

      <vs-button
        @click="isRetidoSemNegociacao()"
        color="success"
        class="mb-2 my-5 ml-2"
      >
        <span>Reter sem negociação</span>
      </vs-button>
    </vs-popup>

    <vs-popup
      :title="'Enviar dados para Comercial'"
      @close="popComercial = false"
      :active.sync="popComercial"
    >
      <div class="con-exemple-prompt">
        <vs-select
          v-model="form.usuarioResponsavel"
          label="Chamado para Usuário Responsável"
          class="select-large w-full mb-3"
          name="Usuário Responsável"
          autocompletes
          :state="validateState('Usuário Responsável')"
          :danger="validateClass('Usuário Responsável')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in usuarios"
          />
        </vs-select>
        <vs-textarea
          v-if="form.idMotivo == 5"
          placeholder="Insira os dados do novo veículo que sera comprado, data prevista de compra e etc."
          v-model="form.observacao"
        />
        <vs-textarea
          v-else
          placeholder="Insira os dados do novo veículo que será comprado para substuir"
          v-model="form.observacao"
        />
      </div>

      <vs-button @click="naoRetido()" color="success" class="mb-2 my-5 ml-2">
        <span>Abrir Chamado para Comercial</span>
      </vs-button>
    </vs-popup>

    <vs-popup
      :title="'Iniciar Negociação'"
      @close="popNegociacao = false"
      :active.sync="popNegociacao"
    >
      <div class="con-exemple-prompt">
        <vs-select
          v-model="form.usuarioResponsavel"
          label="Chamado para Usuário Responsável"
          class="select-large w-full mb-3"
          name="Usuário Responsável"
          autocompletes
          :state="validateState('Usuário Responsável')"
          :danger="validateClass('Usuário Responsável')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in usuarios"
          />
        </vs-select>

        <vs-select
          v-if="form.idMotivo == 4"
          v-model="form.setor"
          label="Setor"
          class="select-large w-full mb-3"
          name="Setor"
          autocompletes
          :state="validateState('Setor')"
          :danger="validateClass('Setor')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in setores"
          />
        </vs-select>

        <vs-textarea
          placeholder="Insira os dados da negociação ou reclamação"
          v-model="form.observacao"
        />
      </div>
      <vs-button @click="isNegociacao()" color="success" class="mb-2 my-5 ml-2">
        <span>Iniciar Processo</span>
      </vs-button>
    </vs-popup>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import swal from 'sweetalert';
import vSelect from 'vue-select';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      iniciar: false,
      popRetido: false,
      popComercial: false,
      popNegociacao: false,
      idEmpresa: null,
      languages: lang,
      dadosResult: null,
      motivos: [],
      setores: [],
      usuarios: [],
      respostasPadrao: [{ id: 'Sim' }, { id: 'Não' }, { id: 'Não sei dizer' }],
      respostasNota: [
        { id: '0' },
        { id: '1' },
        { id: '2' },
        { id: '3' },
        { id: '4' },
        { id: '5' },
        { id: '6' },
        { id: '7' },
        { id: '8' },
        { id: '9' },
        { id: '10' },
      ],
      perguntas: [],
      perguntasFilter: [],
      form: {
        idEmpresa: null,
        placa: '',
        idMotivo: null,
      },
    };
  },
  methods: {
    showOrDont(item) {
      //console.log(item);
      if (item.idPerguntaDependente != null) {
        var aux = this.perguntasFilter.find(
          (x) => x.idPergunta == item.idPerguntaDependente,
        );
        if (!aux) return false;
        if (aux.resposta == item.respostaDependente) return true;
        else return false;
      } else return true;
    },
    IniciaNegociacao() {
      this.popNegociacao = true;
      if (this.form.idMotivo == 4) {
        this.form.observacao = this.perguntasFilter[0].resposta;
      } else {
        this.form.observacao = null;
      }
    },
    buscaDadosSetor() {
      service
        .getAll('Setor', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.setores.push({
              id: element.idSetor,
              label: element.nomeSetor,
            });
          });
        });
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    enviaForm() {
      var bolPerguntas = false;
      var perguntas = this.perguntasFilter.filter(
        (x) => x.resposta == null && x.idPerguntaDependente == null,
      );
      var perguntasDependentes = this.perguntasFilter.filter(
        (x) => x.resposta == null && x.idPerguntaDependente != null,
      );
      if (perguntas.length > 0) {
        bolPerguntas = true;
        console.log('a');
      } else {
        if (perguntasDependentes.length > 0) {
          for (let index = 0; index < perguntasDependentes.length; index++) {
            var element = perguntasDependentes[index];
            var respostaDependente = this.perguntasFilter.find(
              (x) => x.idPergunta == element.idPerguntaDependente,
            );
            if (respostaDependente) {
              if (respostaDependente.resposta == element.respostaDependente) {
                element.obrigatorio = true;
              } else {
                element.obrigatorio = false;
              }
            }
          }
          if (perguntasDependentes.length == 0) {
            bolPerguntas = false;
            console.log('b');
          } else {
            var aux = perguntasDependentes.filter(
              (x) => x.obrigatorio == true && x.resposta == null,
            );
            if (aux.length > 0) {
              bolPerguntas = true;
              console.log('c');
            } else {
              bolPerguntas = false;
              console.log('d');
            }
          }
        }
      }

      console.log(perguntasDependentes);
      console.log(bolPerguntas);

      if (bolPerguntas == true) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Existem perguntas ainda não Respondidas',
          color: 'danger',
        });
      } else {
        this.popComercial = false;
        this.popRetido = false;
        this.popNegociacao = false;

        this.form.dados = this.dadosResult;
        this.form.respostas = this.perguntasFilter;
        //this.$vs.loading();
        if (this.$route.params.idCancelamento) {
          this.form.idCancelamento = this.$route.params.idCancelamento;
          if (this.form.dados.boletos.length > 0) {
            this.form.dados.boletos = [1, 2];
          }
          var codVeiculo = this.form.dados.veiculo.codigo_veiculo;
          this.form.dados.veiculo = {
            codigo_veiculo: codVeiculo,
          };
          this.form.dados.produtos = [];

          console.log(this.form);
          service
            .post('Cancelamento', 'AtualizarProcesso', this.form)
            .then((res) => {
              console.log(res.data);
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Processo de Cancelamento Atualizado com sucesso, você já pode acompanhar na listagem de Cancelamentos',
                color: 'success',
              });
              this.$vs.loading.close();

              this.$router.push('/Cancelamentos');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível Atualizar Processo de Cancelamento',
                color: 'danger',
              });
            });
        } else
          service
            .post('Cancelamento', 'AdicionarProcesso', this.form)
            .then((res) => {
              console.log(res.data);
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Processo de Cancelamento adicionado com sucesso, você já pode acompanhar na listagem de Cancelamentos',
                color: 'success',
              });
              this.$vs.loading.close();

              this.$router.push('/Cancelamentos');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: 'Não foi possível Cadastrar Processo de Cancelamento',
                color: 'danger',
              });
            });
      }
    },
    isRetidoSemNegociacao() {
      this.form.isRetido = true;
      this.form.isSemNegociacao = true;
      this.form.isReducao = false;
      this.form.isSuspensao = false;
      this.enviaForm();
    },
    isReducao() {
      this.form.isRetido = true;
      this.form.isReducao = true;
      this.form.isSemNegociacao = false;
      this.form.isSuspensao = false;
      this.enviaForm();
    },
    isSuspensao() {
      this.form.isRetido = true;
      this.form.isSuspensao = true;
      this.form.isReducao = false;
      this.form.isSemNegociacao = false;
      this.enviaForm();
    },
    isNegociacao() {
      this.popNegociacao = false;
      this.form.isRetido = null;
      this.form.isSuspensao = false;
      this.form.isReducao = false;
      this.form.isSemNegociacao = false;
      this.form.isNegociacao = true;

      this.enviaForm();
    },
    naoRetido() {
      this.form.isRetido = false;
      this.enviaForm();
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
    filtraPerguntas() {
      console.log(this.form.idMotivo, this.perguntas);
      this.perguntasFilter = this.perguntas.filter(
        (x) => x.idMotivo == this.form.idMotivo || x.idMotivo == null,
      );
      this.perguntasFilter.sort(function (a, b) {
        return a.ordenacao < b.ordenacao
          ? -1
          : a.ordenacao > b.ordenacao
          ? 1
          : 0;
      });
    },
    buscarPerguntas() {
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        service
          .getAll(
            'Cancelamento',
            {},
            'BuscarPerguntas/idEmpresa=' + this.idEmpresa,
          )
          .then((res) => {
            this.perguntas = [];
            console.log(this.perguntas);
            this.perguntas = res.data;
            console.log(this.perguntas);
            this.$vs.loading.close();
            resolve();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
            reject();
          });
      });
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    async buscarDados() {
      await this.buscarPerguntas();
      var objSend = {};
      objSend.idCancelamento = this.$route.params.idCancelamento;
      this.$vs.loading();
      service
        .post('Cancelamento', 'BuscarDetalheCancelamento', objSend)
        .then((res) => {
          this.dadosResult = res.data;
          this.iniciar = true;
          this.form.idMotivo = this.dadosResult.cancelamento.id_motivo;
          this.form.placa = this.dadosResult.cancelamento.placa;
          this.filtraPerguntas();
          console.log(res.data);
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.dadosResult = null;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
    buscar() {
      console.log(this.form.placa);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post('Cancelamento', 'BuscarPlaca', this.form)
            .then(async (res) => {
              this.aguardeCadastro = false;
              this.dadosResult = res.data;
              await this.buscarPerguntas();
              console.log(res.data);
              this.$vs.loading.close();
            })
            .catch((error) => {
              console.log(error);
              this.aguardeCadastro = false;
              this.dadosResult = null;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
  },
  mounted() {
    if (this.$route.params.idCancelamento) {
      this.buscarDados();
    }
    this.buscaDadosSetor();

    this.buscaDadosSelects(
      'domMotivoCancelamento',
      'motivos',
      'nomeMotivo',
      'idMotivo',
    );
    this.buscaDadosSelectsPorEmpresa(
      'usuarios',
      'usuarios',
      'nome',
      'idUsuario',
    );
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    'v-select': vSelect,
  },
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 635px !important;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.tableboletos {
  tr td {
    width: 33%;
  }
  tr:nth-child(1) th {
    display: none;
  }
}
.tableboletos:nth-child(1) {
  tr:nth-child(1) th {
    display: table-cell;
  }
}
</style>
<!------------ END SCRIPT ------------>
